import PageImage from 'components/PageImage';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { PageHeader } from 'styles/cssComponents';
import { centeredSection } from 'styles/mixins';
import DocList from '../../components/DocList';
import { getArchive } from '../../services/apiService';

const Wrapper = styled.div`
  ${centeredSection()};
`;

const ArchiwumPage = () => {
    const [docs, setDocs] = useState(null);

    useEffect(() => {
        getArchive().then(data => {
            setDocs(data);
        })
    }, [])

    return (
        <>
            <PageImage url='/assets/archiwum.jpeg'/>
            <Wrapper>
                <PageHeader>Archiwum</PageHeader>
                <DocList items={docs}/>
            </Wrapper>
        </>
    );
};

export default ArchiwumPage;